var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 9.16675C14.7167 9.16675 15.825 8.05008 15.825 6.66675C15.825 5.28341 14.7167 4.16675 13.3334 4.16675C11.95 4.16675 10.8334 5.28341 10.8334 6.66675C10.8334 8.05008 11.95 9.16675 13.3334 9.16675ZM6.66671 9.16675C8.05004 9.16675 9.15837 8.05008 9.15837 6.66675C9.15837 5.28341 8.05004 4.16675 6.66671 4.16675C5.28337 4.16675 4.16671 5.28341 4.16671 6.66675C4.16671 8.05008 5.28337 9.16675 6.66671 9.16675ZM6.66671 10.8334C4.72504 10.8334 0.833374 11.8084 0.833374 13.7501V15.8334H12.5V13.7501C12.5 11.8084 8.60837 10.8334 6.66671 10.8334ZM13.3334 10.8334C13.0917 10.8334 12.8167 10.8501 12.525 10.8751C13.4917 11.5751 14.1667 12.5167 14.1667 13.7501V15.8334H19.1667V13.7501C19.1667 11.8084 15.275 10.8334 13.3334 10.8334Z",
    fill: "#3B3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.46d75f9a1bfc59d44d00f7e6e5e2dfa2.svg";
export { ForwardRef as ReactComponent };